import { useParams } from 'react-router';

import { WorkflowsConfigurationView } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView';
import { EmbeddedViewDataInitialization } from '~/scenes/EmbeddedViews/components/EmbeddedViewDataInitialization/component';
import { EmbeddedViewPath } from '~/scenes/EmbeddedViews/data';
import { HomePageSettings } from '~/scenes/PortalViews/Views/AdminViews/Common/HomePageSettings';
import { PortalBrandingSettings } from '~/scenes/PortalViews/Views/AdminViews/Common/PortalBrandingSettings';
import { requiredReduxData } from '~/scenes/PortalViews/Views/AdminViews/data';

import { CustomTranslationList } from '../AdminModule/components/People/components/ValueLists/CustomTranslations';

export const EmbeddedView = () => {
  const { embeddedView } = useParams<{ embeddedView: string }>();

  const defaultContent = <div>404 Embedded view not found</div>;

  const renderView = () => {
    switch (embeddedView) {
      case EmbeddedViewPath.HomepageSettings:
        return (
          <EmbeddedViewDataInitialization
            required={requiredReduxData.HomePageSettings}
          >
            <HomePageSettings />
          </EmbeddedViewDataInitialization>
        );
      case EmbeddedViewPath.PortalBrandingSettings:
        return (
          <EmbeddedViewDataInitialization
            required={requiredReduxData.PortalBrandingSettings}
          >
            <PortalBrandingSettings />
          </EmbeddedViewDataInitialization>
        );

      case EmbeddedViewPath.WorkflowsAdminView:
        return (
          <EmbeddedViewDataInitialization
            required={requiredReduxData.WorkflowsConfigurationView}
          >
            <WorkflowsConfigurationView />
          </EmbeddedViewDataInitialization>
        );
      case EmbeddedViewPath.CustomTranslations:
        return (
          <EmbeddedViewDataInitialization
            required={requiredReduxData.CustomTranslationList}
          >
            <CustomTranslationList />
          </EmbeddedViewDataInitialization>
        );
      default:
        return defaultContent;
    }
  };

  return renderView();
};
